import { useCallback, useState } from "react"

import type {
  ContentInsertType,
  DiagramEditRequest,
  DiagramEditorSession,
} from "../types"
import type { DiagramSavePayload } from "../utils/diagramNodeAttrs"
import { getEditableDiagramXml } from "../utils/diagramNodeAttrs"

export const useDiagramEditorSession = () => {
  const [session, setSession] = useState<DiagramEditorSession | null>(null)

  const openCreate = useCallback(() => {
    setSession({ mode: "create" })
  }, [])

  const openEdit = useCallback((request: DiagramEditRequest) => {
    setSession({
      mode: "edit",
      pos: request.pos,
      initialXml: getEditableDiagramXml(request.diagramXml),
      initialContentType: request.contentType,
    })
  }, [])

  const close = useCallback(() => {
    setSession(null)
  }, [])

  const isOpen = session !== null

  return {
    session,
    isOpen,
    openCreate,
    openEdit,
    close,
  }
}

export type DiagramEditorSessionApi = ReturnType<typeof useDiagramEditorSession>

export const getInitialDiagramContentType = (
  session: DiagramEditorSession | null
): ContentInsertType =>
  session?.mode === "edit" ? session.initialContentType : "geometry"

export const getInitialDiagramXml = (
  session: DiagramEditorSession | null
): string | undefined =>
  session?.mode === "edit" ? session.initialXml || undefined : undefined

export type { DiagramSavePayload }
